function ExportSlideObjectData(slideIds)
{
	SpectrumMessageBox("Exporting data. Please wait.");
	var fileDownloadFrame = document.createElement("iframe");
	fileDownloadFrame.onload = FileDownloadFrame_Load;
	fileDownloadFrame.id = "FileDownloadFrame";
	fileDownloadFrame.src = "/DoExportSlideObjectData.php?SlideIds=" + slideIds;
	fileDownloadFrame.style.display = "none";
	document.body.appendChild(fileDownloadFrame);
}

function FileDownloadFrame_Load()
{
	HideSpectrumMessageBox();
}